/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#getscrollbarwidth
 */
var feeJS = feeJS || {};
feeJS.getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth + "px";
}



/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#setscrollbarwidth
 */

feeJS.setScrollbarWidth = () => {
  document.documentElement.style.setProperty('--scrollbarWidth', feeJS.getScrollbarWidth());
}